import { createSelector } from 'reselect';

import { EDealType } from 'shared/types/redux/cpd';

import { selectCPDDealType } from './selectCPDDealType';

export const selectAnalyticsCPDDealType = createSelector(selectCPDDealType, dealType => {
  if (!dealType) {
    return null;
  }

  if ([EDealType.Sale, EDealType.SellToBuy].includes(dealType)) {
    return 'sell';
  }

  if (dealType === EDealType.Buy) {
    return 'buy';
  }

  return null;
});
